export default {
  ResendInvoiceTimeout: {
    mounted() {
      const form = this.el;
      const button = form.querySelector('button');

      button.addEventListener('click', () => {
        // Disable the resend invoice button
        button.disabled = true;

        // Submit the form
        form.dispatchEvent(
          new Event('submit', { bubbles: true, cancelable: true }),
        );

        // Re-enable the submit button after 3 seconds to prevent spamming
        setTimeout(() => {
          button.disabled = false;
        }, 3000);
      });
    },
  },
};
